import { Product, DateRange } from 'models/product';

export const getOverallDateRange = (product: Product): DateRange | null => {
  if (!product?.recurrence?.length) {
    return null;
  }

  const overallDateRange: DateRange = {
    start_date_local: product?.recurrence[0]?.start_date_local,
    end_date_local: product.recurrence[0].end_date_local,
  };

  product?.recurrence.forEach((recurrence) => {
    if (recurrence.start_date_local < overallDateRange.start_date_local) {
      overallDateRange.start_date_local = recurrence.start_date_local;
    }
    if (recurrence.end_date_local > overallDateRange.end_date_local) {
      overallDateRange.end_date_local = recurrence.end_date_local;
    }
    recurrence?.additional_date_ranges?.forEach((additionalDateRange) => {
      if (additionalDateRange.start_date_local < overallDateRange.start_date_local) {
        overallDateRange.start_date_local = additionalDateRange.start_date_local;
      }
      if (additionalDateRange.end_date_local > overallDateRange.end_date_local) {
        overallDateRange.end_date_local = additionalDateRange.end_date_local;
      }
    });
  });

  return overallDateRange;
};
